import { FormattedMessage } from "react-intl";

import styles from "@components/labels/HighlightLabel.module.css";
import BodyCopy from "@components/typography/BodyCopy";

type Props = {
  bottomPx?: number;
  leftPx?: number;
  rightPx?: number;
  textKey: string;
  topPx?: number;
};

const HighlightLabel = ({ bottomPx, leftPx, rightPx, textKey, topPx }: Props) => (
  <div className={`${styles.wrapper}`} style={{ bottom: bottomPx, left: leftPx, right: rightPx, top: topPx }}>
    <div className={styles.triangle}></div>
    <BodyCopy bold color="white">
      <FormattedMessage id={textKey} />
    </BodyCopy>
  </div>
);

export default HighlightLabel;
